import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'cards.transactions.error.title',
        defaultMessage: 'Something went wrong',
    },
    text: {
        id: 'cards.transactions.error.text',
        defaultMessage: 'Please refresh the page to try again',
    },
    btn: {
        id: 'cards.transactions.error.btn',
        defaultMessage: 'Refresh',
    },
})
